import { Link as RouterLink } from 'react-router-dom'
// material
import { styled } from '@mui/material/styles'
import { Link, Container, Typography } from '@mui/material'
// components
import Page from '../components/Page'
import { LoginForm } from '../components/authentication/login'
import AuthSidebar from '../layouts/AuthSidebar'

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}))

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}))

// ----------------------------------------------------------------------

export default function Login() {
  return (
    <RootStyle title="Entrar">
      <AuthSidebar>
        <Typography variant="h4" sx={{ px: 10 }} align="center">
          Bem vindo,
        </Typography>
        <Typography variant="h1" sx={{ px: 10 }} align="center">
          Portal Egressos
        </Typography>
      </AuthSidebar>

      <Container maxWidth="sm">
        <ContentStyle>
          {/* <Stack sx={{ mb: 5 }}>
            <Typography variant="h4" gutterBottom>
              Sign in to Minimal
            </Typography>
            <Typography sx={{ color: 'text.secondary' }}>Enter your details below.</Typography>
          </Stack>
          <AuthSocial /> */}

          <LoginForm />
          <Typography variant="body2" align="center" sx={{ mt: 3 }}>
            Novo aqui?&nbsp;
            <Link variant="subtitle2" component={RouterLink} to="/register">
              Cadastre-se
            </Link>
          </Typography>
        </ContentStyle>
      </Container>
    </RootStyle>
  )
}
